import { forwardRef } from "react";
import cn from "classnames";
import { ITextareaProps } from "./Textarea.props";
import styles from "./Textarea.module.scss";

const Textarea = forwardRef<HTMLTextAreaElement, ITextareaProps>(({ className, ...props }: ITextareaProps, ref): JSX.Element => {
	return <textarea ref={ref} className={cn(styles.textarea, className)} {...props} />;
});

export default Textarea;
